module.exports = __webpack_public_path__ + "img/icon.b7f3f68d.png";